<template>
  <div>
    <div class="">
      <div class="text-gray-600 mb-2">
        {{ $t('settings.security.component.twoFactor.validation.text') }}
      </div>
      <div>
        <CInput v-model="confirmationCode" />
      </div>
      <div class="pb-4 text-right" style="text-decoration: underline">
        <CLink :disabled="resendLoading" @click="resendMFACode()">{{ $t('settings.security.component.twoFactor.validation.link') }} </CLink>
      </div>
      <div>
        <CButton color="white" class="py-2 px-5 mr-2" @click="cancelConfirmation()">
          {{ $t('settings.security.component.phoneNumber.popup.button.cancel') }}
        </CButton>
        <CButton :disabled="!isValidatable" color="primary" class="py-2 px-5" @click="loginSMSValidation()">
          {{ $t('settings.security.component.twoFactor.validation.button') }}
        </CButton>
      </div>
    </div>
  </div>
</template>
<script>
import services from '@/services.js'

const mfaPurposeEnum = {
  LOGIN: 0,
  ENABLE_SMS_2FA: 1,
  DISABLE_SMS_2FA: 2,
}

export default {
  props: {
    userId: {
      type: String,
    },
  },
  data() {
    return {
      loadingValidation: false,
      confirmationCode: '',
      resendLoading: false,
    }
  },
  mounted() {
    if (!this.userId) {
      this.$emit('cancelConfirmation')
    }
  },
  computed: {
    isValidatable() {
      return this.confirmationCode.length > 2 && !this.loadingValidation
    },
  },
  methods: {
    cancelConfirmation() {
      this.$emit('cancelConfirmation')
    },

    resendMFACode() {
      let params = {
        userId: this.userId,
        purpose: mfaPurposeEnum.LOGIN,
      }

      services
        .postMFAResend(params)
        .then(() => {
          this.$emit('showSuccess', {
            status: 'success',
            text: this.$t('settings.security.component.twoFactor.validation.resendSuccess'),
          })
        })
        .catch(({ response }) => {
          this.$emit('showMessage', response.data.message)
        })
        .finally(() => setTimeout(() => (this.resendLoading = false), 2000))
    },

    loginSMSValidation() {
      this.loadingValidation = true

      let params = {
        token: this.confirmationCode,
        userId: this.userId,
      }

      this.$store
        .dispatch('auth/loginSMS', params)
        .then((res) => {
          this.$emit('confirmMFAValidation')
        })
        .catch((response) => {
          this.$emit('showMessage', this.$t('general.errors.' + response.data.message))
        })
        .finally(() => (this.loadingValidation = false))
    },
  },
}
</script>
